import { SignInRequired } from "./api";

// Every user action: a lapsed session goes back to sign-in; any other failure is shown, never swallowed.
export async function guard(
  work: Promise<unknown>,
  signIn: () => unknown,
  report: (error: unknown) => void,
): Promise<void> {
  try {
    await work;
  } catch (error) {
    if (error instanceof SignInRequired) signIn();
    else report(error);
  }
}
